import workerManager from "_src/engine/worker_manager";
import { messageType } from "_src/engine/ipc";
import {DEFAULT_ATTRIBUTES, DEFAULT_NO_INDICES_ATTRIBUTES} from "_src/engine/utility/attributes";
import workerPool from "_src/engine/worker_pool";
import {writeChunk} from "_src/engine/loaders/utils"

// NOTE: this module is only loaded in nodejs build (see webpack.config.js)
import zstdCoder from "_zstdCoderModule";

export default {

  async encodeMain(geometry, compressionLevel) {
    const data = prepareGeometryData(geometry, compressionLevel);
    const encoder = await zstdCoder.getCoder();
    const result = writeChunk(data, "zstd", encoder);
    return result.arrayBuffer;
  },

  encodeWorker(geometry, compressionLevel) {

    const data = prepareGeometryData(geometry, compressionLevel);

    const transfer = [];

    const message = {
      type: messageType.ENCODE_ZSTD,
      buffersData: data
    };

    const savingAttributes = geometry.isPointCloud ? DEFAULT_NO_INDICES_ATTRIBUTES : DEFAULT_ATTRIBUTES;
    for (let i = 0; i < savingAttributes.length; ++i) {

      const name = savingAttributes[i];
      const item = geometry.getLayoutItem(name);

      if (item) {
        if (item.isDetached()) {
          return Promise.reject("Can't encode geometry. " + name + " buffer is detached.");
        }

        const attributeBuffer = item.getBuffer();
        transfer.push(attributeBuffer.buffer);
        item.setIsDetached(true);
      }

    }

    return workerManager.sendMessage(message, transfer).then((result) => {

      for (let i = 0; i < savingAttributes.length; ++i) {

        const name = savingAttributes[i];
        const item = geometry.getLayoutItem(name);

        if (item) {
          item.setBuffer(result.data[name].buffer);
        }

      }

      return result.data.arrayBuffer;

    });

  },

  cleanup() {
    workerPool.cleanup(messageType.ENCODE_ZSTD);
    return Promise.resolve();
  }

}

function prepareGeometryData(geometry, compressionLevel) {

  const data = {level: compressionLevel};

  const savingAttributes = geometry.isPointCloud ? DEFAULT_NO_INDICES_ATTRIBUTES : DEFAULT_ATTRIBUTES;
  for (let i = 0; i < savingAttributes.length; ++i) {

    const name = savingAttributes[i];
    const buffer = geometry.getItemBuffer(name);

    if (buffer) {
      data[name] = buffer;
    }

  }

  return data;

}
